const initializeYouMightAlsoLike = (section) => {
  if (!section || section.dataset.youMightAlsoLikeInitialized === 'true') return;

  section.dataset.youMightAlsoLikeInitialized = 'true';

  const grid = section.querySelector('.product-you-might-also-like__grid');
  const productId = section.dataset.productId;
  const productLimit = Number(section.dataset.productLimit);
  const recommendationsUrl = section.dataset.recommendationsUrl;
  const sectionId = section.dataset.sectionId;

  if (!grid || !productId || !productLimit || !recommendationsUrl || !sectionId) return;

  const fallbackCards = Array.from(grid.querySelectorAll('[data-product-card]'));

  const fetchRecommendations = async (intent) => {
    const url = new URL(recommendationsUrl, window.location.origin);
    url.searchParams.set('product_id', productId);
    url.searchParams.set('limit', String(productLimit));
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('intent', intent);

    const response = await fetch(url.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!response.ok) throw new Error(`Unable to load ${intent} product recommendations`);

    const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
    return Array.from(responseDocument.querySelectorAll('[data-you-might-also-like-results] [data-product-card]'));
  };

  Promise.allSettled([fetchRecommendations('complementary'), fetchRecommendations('related')]).then(
    (results) => {
      const complementaryCards = results[0].status === 'fulfilled' ? results[0].value : [];
      const relatedCards = results[1].status === 'fulfilled' ? results[1].value : [];
      const seenProductIds = new Set([productId]);
      const selectedCards = [];

      for (const card of [...complementaryCards, ...relatedCards, ...fallbackCards]) {
        const recommendedProductId = card.dataset.productId;
        if (!recommendedProductId || seenProductIds.has(recommendedProductId)) continue;

        seenProductIds.add(recommendedProductId);
        selectedCards.push(card);
        if (selectedCards.length >= productLimit) break;
      }

      grid.replaceChildren(...selectedCards);

      window.requestAnimationFrame(() => {
        section.querySelectorAll('[data-product-card]').forEach((card) => {
          const selectedButton = card.querySelector('[data-variant-button].is-selected');
          const variantSelector = selectedButton?.closest('.cp-card__variants');
          if (selectedButton && variantSelector?.classList.contains('has-multiple')) {
            variantSelector.style.setProperty('--selected-variant-left', `${selectedButton.offsetLeft}px`);
            variantSelector.style.setProperty('--selected-variant-width', `${selectedButton.offsetWidth}px`);
          }
        });
      });
    }
  );
};

const initializeAllYouMightAlsoLikeSections = (container = document) => {
  container.querySelectorAll('[data-you-might-also-like]').forEach(initializeYouMightAlsoLike);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeAllYouMightAlsoLikeSections());
} else {
  initializeAllYouMightAlsoLikeSections();
}

document.addEventListener('shopify:section:load', (event) => {
  initializeAllYouMightAlsoLikeSections(event.target);
});
